<template>
	<div class="index">
		<RobotSocket ref="robotSocketRef" :nowTime='nowTime' @backSockertData='doSocker($event)' />
		<div class="heard">
			<img :src="headUrl" />
			<div>智能机器人监控平台</div>
		</div>
		<div class="content">
			<div class="content-div left">
				<div class="content-title">监控地图</div>
				<div class="left-div"><img v-for="(obj, index) in mapAry" :key="index" :src="obj.address"
						@error='changeError()' :class="obj.check ? 'checkImage' : ''" @click="getMapDetail(index)" />
				</div>
			</div>

			<div class="content-div check">
				<div class="content-div-check" :style="{ width: vWidth + 'px', height: vHeight + 'px' }">
					<img :src="backUrl" @error='changeErrorIndex()' />
					<div class="robot" ref="robot" v-for="(obj, index) in mapRobotAry" :key="index">
						<!-- <img :src="robotSrc" alt=""> -->
						<div style="white-space: nowrap;">{{ obj.number }}</div>
					</div>
				</div>
			</div>

			<div class="right1">
				<div class="content-div">
					<div class="content-title">报警统计</div>
					<div class="body" id="body-li1">
						<div class="title">总数</div>
						<div class="content">
							<div class="left">
								<div class="value1"></div>
							</div>
							<div class="right">{{ errorData.totalNum }}件</div>
						</div>
						<div class="title-2">未处理</div>
						<div class="content">
							<div class="left" style="border: 1px solid #26CCFF;">
								<div class="value2" :style="{ width: errorData.percen + '%' }"></div>
							</div>
							<div class="right" style="color: #00BDE2;">{{ errorData.untreatedNum }}件</div>
						</div>
					</div>
				</div>
				<div class="content-div right1-2">
					<div class="content-title">数据分析</div>
					<div class="body" id="body-li2"></div>
				</div>
				<div class="content-div">
					<div class="content-title">系统报告</div>
					<div class="body" id="body-li3"></div>
				</div>
			</div>

			<div class="right2">
				<div class="content-div-right right2-1">
					<div class="content-title">机器人</div>
					<div class="top">
						<div>总数 {{ errorObj.totalNum }}</div>
						<div>在岗 {{ errorObj.onDuty }}</div>
					</div>
					<div class="body">
						<div v-for="(obj, index) in robotAry" :key="index">
							<span>{{ obj.robotName }}</span>
							<span>{{ obj.routeName }}</span>
							<span>{{ obj.onlineStatus === '1' ? obj.ststusName : '离线'}}</span>
						</div>
					</div>
				</div>
				<div class="content-div-right right2-2">
					<div class="content-title">实时报警</div>
					<div class="title">
						<div>时间</div>
						<div>上报人</div>
						<div>上报内容</div>
						<div>处理状态</div>
					</div>
					<div class="body">
						<div v-for="(obj, index) in eventAry" :key="index"
							:class="obj.results === '1' ? 'body-li' : 'body-li error-li'">
							<div>{{ obj.insDate }}</div>
							<div>{{ obj.rName }}</div>
							<div class="text">{{ obj.eName }}</div>
							<div class="text">{{ obj.resultsName }}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped lang="less"></style>

<script>
	import {
		allEventStatistics,
		mapList,
		robotList,
		eventList,
		robotNum,
		eventChart,
		mapEventChart,
		positonList,
		rIndex
	} from '@/api/index'
	import {
		getItem
	} from '@/utils/auth'
	import RobotSocket from '@/components/RobotSocket.vue'
	import '@/page/index/index.less'

	export default {
		name: 'index',
		components: {
			RobotSocket
		},
		data() {
			return {
				nowTime: new Date().getTime(),
				headUrl: require('../../../static/img/index_head.png'),
				robotSrc: require('../../../static/img/xyRobot.png'),
				backUrl: '',
				mapAry: [],
				robotAry: [],
				mapRobotAry: [],
				mapRobotColor: ['#FF0000', '#8B008B', '#4B0082', '#4B0082', '#2F4F4F', '#008B8B', '#FF8C00', '#006400',
					'#000000'
				],
				vWidth: 0,
				vHeight: 0,
				errorData: {
					totalNum: 0,
					untreatedNum: 0,
					percen: 0
				},
				eventAry: [],
				errorObj: {
					onDuty: 0,
					totalNum: 0
				}
			}
		},
		mounted() {
			// 定时执行保持token有效
			setInterval(function() {
				rIndex()
			}, 1000 * 60 * 60 * 5)
			if (getItem('userInfo').positionType === '2') {
				this.$message({
					message: '抱歉，此账号暂无权限',
					type: 'warning',
					duration: 2000,
					onClose() {
						window.history.back(-1);
					}
				});
			} else {
				let that = this
				let tenID = getItem('tenantInfoId')
				setTimeout(function() {
					that.mapEventChart(tenID)
					that.eventChart(tenID)
				}, 500)
				this.allEventStatistics(tenID)
				this.mapList(tenID)
				this.robotList(tenID)
				this.eventList(tenID)
				this.robotNum(tenID)
			}
		},
		updated() {
			let that = this
			if (that.$refs.robot && that.$refs.robot.length > 0) {
				that.$refs.robot.map((v, index) => {
					v.style.top = Number(that.mapRobotAry[index].positon.split(',')[0]) - 4 + 'px'
					v.style.left = Number(that.mapRobotAry[index].positon.split(',')[1]) - 4 + 'px'
					// if (that.mapRobotColor[index]) {
					//   v.style.color = that.mapRobotColor[index]
					// } else {
					//   v.style.color = 'black'
					// }
				})
			}
		},
		destroyed() {},
		methods: {
			doSocker(socketData) {
				let that = this
				if (socketData.socketType === '1') {
					that.mapRobotAry.map(v => {
						if (v.robotId === socketData.robotId) {
							v.positon = socketData.positon
						}
					})
					for (let i = 0; i < that.robotAry.length; i++) {
						if (that.robotAry[i].robotId === socketData.robotId) {
							that.robotAry[i].ststusName = socketData.ststusName
						}
					}
					that.robotAry = JSON.parse(JSON.stringify(that.robotAry))
					that.mapRobotAry = JSON.parse(JSON.stringify(that.mapRobotAry))
				} else if (socketData.socketType === '2' || socketData.socketType === '4' || socketData.socketType ===
					'6' || socketData.socketType === '7') {
					let tenID = getItem('tenantInfoId')
					that.mapEventChart(tenID)
					that.eventChart(tenID)
					that.allEventStatistics(tenID)
					that.eventList(tenID)
					that.robotList(tenID)
				}
			},
			getMapDetail(index) {
				let that = this
				that.mapAry.map(v => {
					v.check = false
				})
				that.mapAry[index].check = true
				that.mapAry = JSON.parse(JSON.stringify(that.mapAry))
				that.backUrl = that.mapAry[index].address
				that.vWidth = Number(that.mapAry[index].width)
				that.vHeight = Number(that.mapAry[index].height)
				positonList({
					number: that.mapAry[index].number,
					userId: getItem('userInfo').staffId
				}).then(res => {
					if (res && res.data.length > 0) {
						that.mapRobotAry = res.data
					} else {
						that.mapRobotAry = []
					}
				})
			},
			robotNum(id) {
				let that = this
				robotNum(id).then(res => {
					that.errorObj = res.data
				})
			},
			mapEventChart(id) {
				let that = this
				mapEventChart(id).then(res => {
					that.Echarts2(res.data)
				})
			},
			eventChart(id) {
				let that = this
				eventChart(id).then(res => {
					that.Echarts3(res.data)
				})
			},
			eventList(id) {
				let that = this
				eventList(id).then(res => {
					if (res.data && res.data.length > 0) {
						that.eventAry = res.data
					} else {
						that.eventAry = []
					}
				})
			},
			robotList(id) {
				let that = this
				robotList(id).then(res => {
					if (res.data && res.data.length > 0) {
						that.robotAry = res.data
					} else {
						that.robotAry = []
					}
				})
			},
			mapList(id) {
				let that = this
				mapList(id).then(res => {
					if (res.data && res.data.length > 0) {
						that.mapAry = res.data
						that.mapAry.map(v => {
							v.check = false
						})
						that.backUrl = that.mapAry[0].address
						that.vWidth = Number(that.mapAry[0].width)
						that.vHeight = Number(that.mapAry[0].height)
						that.getMapDetail(0)
					} else {
						that.mapAry = []
					}
				})
			},
			allEventStatistics(id) {
				let that = this
				allEventStatistics(id).then(res => {
					if (res.data) {
						that.errorData = res.data
						that.errorData.percen = (that.errorData.untreatedNum / that.errorData.totalNum) * 100
					}
				})
			},
			Echarts2(echarArray) {
				var myChart = this.$echarts.init(document.getElementById('body-li2'))
				echarArray.map(v => {
					v.value = Number(v.number)
				})
				var datas = [echarArray]
				var option = {
					tooltip: {
						trigger: 'item',
						formatter: '{b}: {c} ({d}%)'
					},
					series: datas.map(function(data, idx) {
						return {
							type: 'pie',
							radius: [30, '70%'],
							label: {
								alignTo: 'edge',
								formatter: '{time|{c}}\n{name|{b}}',
								edgeDistance: 10,
								lineHeight: 20,
								rich: {
									time: {
										fontSize: 10
									},
									textStyle: {
										color: 'gray'
									}
								}
							},
							labelLine: {
								length: 15,
								length2: 0,
								maxSurfaceAngle: 80
							},
							labelLayout: function(params) {
								var isLeft = params.labelRect.x < myChart.getWidth() / 2
								var points = params.labelLinePoints
								points[2][0] = isLeft ? params.labelRect.x : params.labelRect.x + params
									.labelRect.width
								return {
									labelLinePoints: points
								}
							},
							data: data
						}
					})
				}
				// var option = {
				//   tooltip: {
				//     trigger: 'axis'
				//   },
				//   areaStyle: {
				//     color: '#f9c761'
				//   },
				//   radar: [
				//     {
				//       indicator: [{ text: '品牌', max: 100 }, { text: '内容', max: 100 }, { text: '可用性', max: 100 }, { text: '功能', max: 100 }, { text: '功11能', max: 100 }],
				//       center: ['50%', '50%'],
				//       radius: 70,
				//       splitLine: {
				//         lineStyle: {
				//           color: '#17679b'
				//         }
				//       },
				//       splitArea: {
				//         show: true,
				//         areaStyle: {
				//           color: ['#073361', '#164365']
				//         }
				//       }
				//     }
				//   ],
				//   series: [
				//     {
				//       type: 'radar',
				//       tooltip: {
				//         trigger: 'item'
				//       },
				//       areaStyle: {},
				//       data: [
				//         {
				//           value: [60, 2, 85, 40, 45],
				//           name: '某软件',
				//           itemStyle: {
				//             normal: {
				//               color: 'white'
				//             }
				//           }
				//         }
				//       ]
				//     }
				//   ]
				// }
				myChart.setOption(option)
			},
			Echarts3(echarArray) {
				var myChart = this.$echarts.init(document.getElementById('body-li3'))
				echarArray.map(v => {
					v.value = Number(v.number)
				})
				var datas = [echarArray]
				var option = {
					tooltip: {
						trigger: 'item',
						formatter: '{b}: {c} ({d}%)'
					},
					series: datas.map(function(data, idx) {
						return {
							type: 'pie',
							radius: [30, '70%'],
							label: {
								alignTo: 'edge',
								formatter: '{time|{c}}\n{name|{b}}',
								edgeDistance: 10,
								lineHeight: 20,
								rich: {
									time: {
										fontSize: 10
									},
									textStyle: {
										color: 'gray'
									}
								}
							},
							labelLine: {
								length: 15,
								length2: 0,
								maxSurfaceAngle: 80
							},
							labelLayout: function(params) {
								var isLeft = params.labelRect.x < myChart.getWidth() / 2
								var points = params.labelLinePoints
								points[2][0] = isLeft ? params.labelRect.x : params.labelRect.x + params
									.labelRect.width
								return {
									labelLinePoints: points
								}
							},
							data: data
						}
					})
				}
				myChart.setOption(option)
			},
			changeError() {
				let that = this
				for (let i = 0; i < that.mapAry.length; i++) {
					that.mapAry[i].address = that.mapAry[i].address
				}
				that.mapAry = JSON.parse(JSON.stringify(that.mapAry))
			},
			changeErrorIndex() {
				if (this.backUrl.indexOf("=") !== -1) {
					this.backUrl = this.backUrl.split("=")[1]
				} else {
					this.backUrl = this.backUrl
				}
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/page/index/index.vue